import {CampaignTypes} from '../../../../types/src';

export const getCampaignTypes = (value: string) => {
  switch (value.toLowerCase()) {
    case CampaignTypes.Acquisition:
      return {value: 'Acquisition', color: '#5cb85c'};
    case CampaignTypes.AcquisitionBasic:
      return {value: 'Acquisition', color: '#5cb85c'};
    case CampaignTypes.AcquisitionCsv:
      return {value: 'Acquisition (CSV)', class: 'acquisition-csv-tag'};
    case CampaignTypes.AcquisitionViaImport:
      return {value: 'Acquisition+', color: '#1a6e2f'};
    case CampaignTypes.AcquisitionMessageRequest:
      return {value: 'Acquisition (Groups) Beta', color: '#1a6e2f'};
    case CampaignTypes.Retention:
      return {value: 'Nurturing', color: '#98d9d9'};
    case CampaignTypes.RetentionCsv:
      return {value: 'Nurturing (CSV)', class: 'nurturing-csv-tag'};
    case CampaignTypes.RetentionTags:
      return {value: 'Nurturing (Tag)', class: 'nurturing-csv-tag'};
    case CampaignTypes.RetentionActions:
      return {value: 'Nurturing (Action)', class: 'nurturing-csv-tag'};
    case CampaignTypes.RetentionCsvAudienceList:
      return {value: 'Nurturing (Audience List)', class: 'nurturing-csv-tag'}
    case CampaignTypes.AcquisitionCsvAudienceList:
      return {value: 'Acquisition (Audience List)', class: 'acquisition-csv-tag'}
    case CampaignTypes.AcquisitionCsvEnrichment:
      return {value: 'Acquisition (Enrichment List)', class: 'acquisition-csv-tag'}
    case CampaignTypes.RetentionCsvEnrichment:
      return {value: 'Nurturing (Enrichment List)', class: 'nurturing-csv-tag'}
    case CampaignTypes.AcquisitionInmail:
      return {value: 'Acquisition+ (Inmail)', class: 'acquisition-csv-tag'};
    case CampaignTypes.AcquisitionCsvInstantly:
      return {value: 'Acquisition (Instantly)', class: 'acquisition-csv-tag'};
    case CampaignTypes.AcquisitionCsvRb2b:
      return {value: 'Acquisition (RB2B)', class: 'acquisition-csv-tag'};
    case CampaignTypes.AcquisitionCsvSquid:
      return {value: 'Acquisition (Squid)', class: 'acquisition-csv-tag'};
    case CampaignTypes.AcquisitionCsvApi:
      return {value: 'Acquisition (API)', class: 'acquisition-csv-tag'};
    case CampaignTypes.AcquisitionCsvWebhook:
      return {value: 'Acquisition (Webhook)', class: 'acquisition-csv-tag'};
    case CampaignTypes.AcquisitionCsvVector:
      return {value: 'Acquisition (Vector)', class: 'acquisition-csv-tag'};
    case CampaignTypes.AcquisitionCsvZapier:
      return {value: 'Acquisition (Zapier)', class: 'acquisition-csv-tag'};
    case CampaignTypes.AcquisitionCsvLikedPost:
      return {value: 'Acquisition (Post Likes)', class: 'acquisition-csv-tag'}
    case CampaignTypes.AcquisitionCsvAudienceList:
      return {value: 'Acquisition (Audience List)', class: 'acquisition-csv-tag'}
    default:
      return {value: 'No type', color: 'gray'};
  }
};
